export default __webpack_public_path__ + "static/media/goshen42.205eeaa2.jpg";